import React from "react";
import ReactApexChart from "react-apexcharts";

const SimplePieChart = ({graph}) => {
  const chartData = {
    series: graph?.totalData,
    options: {
      chart: {
        type: "pie",
      },
      labels: graph?.totalCategory,
      legend: {
        position: "bottom",
      },
      colors: graph?.categoryColor?.map(item => item?.color) ?? [],
    },
  };

  return (
    <div>
      <div id="chart">
        <ReactApexChart
          options={chartData.options}
          series={chartData.series}
          type="pie"
          height={280}
        />
      </div>
    </div>
  );
};

export default SimplePieChart;
